// Amplitude initialization with Session Replay Call initAmplitude() once on app startup (in AmplitudeProvider)

import * as amplitude from '@amplitude/analytics-browser';
import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser';
import config from '@/constants/config';

let isInitialized = false;

export function initAmplitude(): void {
  if (typeof window === 'undefined') return;
  if (isInitialized) return;

  const apiKey = config.amplitudeApiKey;
  if (!apiKey) {
    console.warn('[Amplitude] No API key configured, skipping initialization');
    return;
  }

  const sessionReplay = sessionReplayPlugin({
    sampleRate: 0.2,

    // Privacy: Only block payment fields (PCI compliance) All other inputs remain visible for debugging
    privacyConfig: {
      blockSelector: [
        '.card-element',
        '[data-stripe]',
        '.StripeElement',
        'input[name="cardNumber"]',
        'input[name="cvc"]',
        'input[name="expiry"]',
      ],
    },
  });

  amplitude.add(sessionReplay);

  amplitude.init(apiKey, {
    autocapture: {
      elementInteractions: true,
      pageViews: true,
      sessions: true,
      formInteractions: true,
      fileDownloads: false,
    },

    defaultTracking: {
      attribution: true,
      pageViews: true,
      sessions: true,
      formInteractions: true,
      fileDownloads: false,
    },

    flushIntervalMillis: 1000,
    flushQueueSize: 10,
    flushMaxRetries: 5,

    cookieOptions: {
      domain: '.thisisdelmar.com',
      sameSite: 'Lax',
      secure: true,
      expiration: 365,
    },

    logLevel: amplitude.Types.LogLevel.Warn,
  });

  isInitialized = true;
  console.log('[Amplitude] Initialized with Session Replay');
}

export function getAmplitudeDeviceId(): string | undefined {
  if (!isInitialized) return undefined;
  return amplitude.getDeviceId();
}

export function getAmplitudeSessionId(): number | undefined {
  if (!isInitialized) return undefined;
  return amplitude.getSessionId();
}

export function isAmplitudeInitialized(): boolean {
  return isInitialized;
}
